var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TimePicker"},[_c('vc-date-picker',{attrs:{"mode":"time"},on:{"input":function($event){return _vm.$emit('input', _vm.selectedTime)}},model:{value:(_vm.selectedTime),callback:function ($$v) {_vm.selectedTime=$$v},expression:"selectedTime"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }